import React from 'react';

import { MCButton, SearchTextField, SelectField, TabMenu } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import AnalysesList from 'src/components/analyse/list';
import TreatmentsList from 'src/components/treatments/list';
import JourneyTimeline from 'src/components/timeline/JourneyTimeline';
import CreateJourney from 'src/components/timeline/Journey/create';

import { lang, permissions, remCss, withRouter } from 'src/helpers';
import { popupModel } from 'src/components/complex';

import model from './model';

import analysesModel from './analysesModel';
import treatmentsModel from './treatmentsModel';
import timelineModel from './timelineModel';
import LANG_CONST from 'src/helpers/lang/const';

const { ACTIONS } = permissions;

const tabs = [
  { id: 'analyses', name: 'Analyses' },
  { id: 'treatment', name: 'Treatment' },
  { id: 'timeline', name: 'Diary' }
];

class Treatments extends BaseComponent {
  constructor(props) {
    super(props);

    if (this.props.router.location?.state?.tab) {
      this.changeTab({ id: this.props.router.location.state?.tab });
    }
  }

  componentDidMount() {
    model.subscribe(this.subscription);
    timelineModel.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    timelineModel.unsubscribe(this.subscription);
  }

  getActiveModel = () => {
    const tab = model.getTab('main_treatment');
    return tab === 'treatment'
      ? treatmentsModel
      : tab === 'timeline'
        ? timelineModel
        : analysesModel;
  };

  changeTab = (tab) => {
    model.changeTab('main_treatment', tab.id);
  };

  render() {
    if (model.state.user?.isDoctor) {
      return (
        <div className={'mc-container-content'}>
          <div className={'mc-container-content__header mc-flex-15'}>
            <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.treatments)}</span>
            <SearchTextField
              width={300}
              template={'2'}
              onChange={treatmentsModel.handleChangeSearch}
              value={treatmentsModel.listInput('search')}
            />
            <SelectField
              width={remCss(150)}
              options={[
                { value: 'all', label: 'All' },
                { value: 'upcoming', label: 'Upcoming' },
                { value: 'completed', label: 'Past' }
              ]}
              template={5}
              isClearable={false}
              name={'status'}
              value={treatmentsModel.input('status')}
              onChange={(name, v) => {
                treatmentsModel.handleChange('status', v);
                treatmentsModel.refresh();
              }}
            />
          </div>
          <div className={' mc-container-content__body mc-p20'}>
            <TreatmentsList model={treatmentsModel} onlyMine={true} />
          </div>
        </div>
      );
    }
    const tab = model.getTab('main_treatment');
    return (
      <div className={'mc-container-content'}>
        <div className={'mc-container-content__header mc-flex-15'}>
          <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.analyses)}</span>
          <SearchTextField
            width={300}
            template={'2'}
            onChange={this.getActiveModel().handleChangeSearch}
            value={this.getActiveModel().listInput('search')}
          />
          {tab === 'timeline' && ACTIONS.JOURNEY_ADD_BUTTON.isActive && (
            <div className={'mc-flex-col'}>
              <MCButton
                medium
                primary
                dark
                radius
                flex
                onClick={() => {
                  popupModel.setActivePopup(ACTIONS.JOURNEY_ADD_BUTTON.key, {
                    active: true,
                    component: CreateJourney,
                    props: { model: timelineModel }
                  });
                }}
              >
                {lang.t(LANG_CONST.buttons.new_diary)}
              </MCButton>
            </div>
          )}
        </div>
        <div className={'mc-container-content__body'}>
          <TabMenu tabs={tabs} tab={{ id: tab }} setTab={this.changeTab} />
          <div className={'mc-tab-box-opacity mc-grow'} style={{ overflow: 'hidden' }}>
            <div
              className={'mc-tab-content mc-flex-col ' + (tab === 'treatment' ? '' : 'mc-inactive')}
            >
              <TreatmentsList
                model={treatmentsModel}
                router={this.props.router}
                onlyMine={true}
                showDoctor={true}
                onPrivacySettings={treatmentsModel.updatePrivacySettings}
              />
            </div>
            <div
              className={'mc-tab-content mc-flex-col ' + (tab === 'analyses' ? '' : 'mc-inactive')}
            >
              <AnalysesList
                model={analysesModel}
                onlyMine={true}
                showPrivacySetting={true}
                onPrivacySettings={analysesModel.updatePrivacySettings}
              />
            </div>
            <div
              className={
                'mc-tab-content mc-flex-col mc-p20 ' + (tab === 'timeline' ? '' : 'mc-inactive')
              }
            >
              <JourneyTimeline model={timelineModel} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Treatments);
